module.exports = __webpack_public_path__ + "assets/logo_onward_verical.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_onward_verical.png
 ** module id = 144
 ** module chunks = 1
 **/